// extracted by mini-css-extract-plugin
export default {"tabBar":"TabBar_tabBar__VeC75","tab":"TabBar_tab__QJMjY","active":"TabBar_active__rZLno"};